import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Discovery",
    desc: "We audit your funnel, brand, data, and competitors. No fluff — a written diagnostic in week one.",
  },
  {
    n: "02",
    title: "Strategy",
    desc: "A single-page growth plan. Channels, hypotheses, KPIs. You sign off before we touch a pixel.",
  },
  {
    n: "03",
    title: "Execution",
    desc: "Creatives, code, campaigns. Fortnightly sprints with real humans on Slack, not tickets.",
  },
  {
    n: "04",
    title: "Scale",
    desc: "Once we hit stable ROAS, we compound: budgets, geographies, new channels, new products.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-24 md:py-32 lg:py-40 border-b border-zinc-200"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Sticky left */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-32">
              <div className="text-xs font-mono uppercase tracking-widest text-zinc-500 mb-4">
                [ 04 — HOW WE WORK ]
              </div>
              <h2
                data-testid="process-title"
                className="font-display font-black uppercase tracking-tighter leading-none text-5xl md:text-6xl lg:text-7xl"
              >
                Four gears. <br />
                <span className="text-[#002FA7]">Zero</span> <br />
                theatre.
              </h2>
              <p className="mt-8 text-zinc-600 max-w-md leading-relaxed">
                Every engagement follows the same operating rhythm — from
                diagnostic to distribution — so you always know what&apos;s shipping
                next and why.
              </p>
            </div>
          </div>

          {/* Steps */}
          <div className="lg:col-span-7 space-y-8 md:space-y-12">
            {steps.map((s, i) => (
              <motion.div
                key={s.n}
                data-testid={`process-step-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ delay: i * 0.08, duration: 0.6 }}
                className="grid grid-cols-12 gap-6 border-t border-zinc-200 pt-8 md:pt-10"
              >
                <div className="col-span-3 md:col-span-2">
                  <div className="font-display font-black text-5xl md:text-6xl text-[#002FA7] leading-none">
                    {s.n}
                  </div>
                </div>
                <div className="col-span-9 md:col-span-10">
                  <h3 className="font-display font-bold uppercase text-2xl md:text-3xl mb-3 tracking-tight">
                    {s.title}
                  </h3>
                  <p className="text-zinc-600 leading-relaxed max-w-xl">
                    {s.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
